export default "__VITE_ASSET__BeVjIEUF__"